import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import Helmet from "react-helmet";



@autobind
class FacebookLoginButton extends React.Component {

  componentDidMount() {
    document.addEventListener('FBObjectReady', this.initializeFacebookLogin);
  }

  componentWillMount() {
    document.addEventListener('FBObjectReady', this.initializeFacebookLogin);
  }

  componentWillUnmount() {
    document.removeEventListener('FBObjectReady', this.initializeFacebookLogin);
  }


  initializeFacebookLogin(){
    this.FB = window.FB;
    console.log("FB- READY");
  }


  facebookLogin(){
    if (!this.FB) return;
    this.FB.getLoginStatus(response => {
      if (response.status === 'connected') {
        this.facebookLoginHandler(response);
      } else {
        this.FB.login(this.facebookLoginHandler, {scope: 'instagram_basic, pages_show_list, pages_manage_metadata, pages_read_user_content'});
      }
    }, );
  }



  facebookLoginHandler(response){
    console.log(response)
    var redirect = "";
    if(response.status === 'connected'){
      console.log(response.authResponse.accessToken)
      var token = response.authResponse.accessToken;
      var userID = response.authResponse.userID;
      if(process.env.NODE_ENV){
        if(process.env.NODE_ENV === "production"){
          redirect =  "https://login.minimaa.co/login/"+token+"/"+userID
        } else if(process.env.NODE_ENV === "test"){
          redirect =  "https://login.minimaa.io/login/"+token+"/"+userID
        } else {
          redirect = "http://localhost:4000/login/"+token+"/"+userID 
        }
        console.log(redirect)
        window.location.replace(redirect);
      } else {
        if(window.location.host.split("minimaa.io")[0].length < window.location.host.length){
          redirect =  "https://login.minimaa.io/login/"+token+"/"+userID
        } else if(window.location.host.split("localhost:3000")[0].length < window.location.host.length){
          redirect = "http://localhost:4000/login/"+token+"/"+userID 
        } else {
          redirect =  "https://login.minimaa.co/login/"+token+"/"+userID
        }
        console.log(redirect)
        window.location.replace(redirect);
      }
    } else {

    }
  }




  setFacebookTag() {
    return {
      __html: `
        cosnole.log("brah")
        window.fbAsyncInit = function() {
          FB.init({
            appId      : '2576292209310738',
            cookie     : true,
            xfbml      : true,
            version    : 'v6.0'
          });
          var fbInitEvent = new Event('FBObjectReady');
          document.dispatchEvent(fbInitEvent);
          FB.AppEvents.logPageView();

        };

        (function(d, s, id){
           var js, fjs = d.getElementsByTagName(s)[0];
           if (d.getElementById(id)) {return;}
           js = d.createElement(s); js.id = id;
           js.src = "https://connect.facebook.net/en_US/sdk.js";
           fjs.parentNode.insertBefore(js, fjs);
         }(document, 'script', 'facebook-jssdk'));
      `
    };
  }

  render() {
    let {children} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <script>
          {`
            window.fbAsyncInit = function() {
              FB.init({
                appId      : '2576292209310738',
                cookie     : false,
                xfbml      : true,
                version    : 'v6.0'
              });
              var fbInitEvent = new Event('FBObjectReady');
              document.dispatchEvent(fbInitEvent);
              FB.AppEvents.logPageView();

            };

            (function(d, s, id){
               var js, fjs = d.getElementsByTagName(s)[0];
               if (d.getElementById(id)) {return;}
               js = d.createElement(s); js.id = id;
               js.src = "https://connect.facebook.net/en_US/sdk.js";
               fjs.parentNode.insertBefore(js, fjs);
             }(document, 'script', 'facebook-jssdk'));
          `}
          </script>
        </Helmet>
        <div onClick={this.facebookLogin}>
          {children}
        </div>
      </React.Fragment>
    );
  }
}


export default FacebookLoginButton;